import { isStrictPasswordPolicyEnabled } from '@/service/administratorPassword/isStrictPasswordPolicyEnabled';
import { setupPasswordFieldErrors } from '@/service/administratorPassword/setupPasswordFieldErrors';
import { isPasswordChangeRequiredSuppressed } from '@/service/administratorPassword/passwordChangeRequiredSuppression';
import { clearCurrentPasswordWaiver } from '@/service/administratorPassword/clearCurrentPasswordWaiver';

// 旧世代側（manage/js/profile.js, manage/js/controller 配下）のコントローラから新パスワードポリシーのフラグ判定、
// パスワード入力欄のエラー振り分け、パスワード変更促進画面の再表示抑止の判定、現在パスワードの検証免除期限のクリアを
// 使うためのブリッジ。
// 下位の isExistFeatureFlag / isBetaFacility が内部で例外を吸収して false を返すため、ここでの try/catch は不要。
angular.module('inspinia').factory('administratorPasswordService', function ($http) {
  return {
    isStrictPasswordPolicyEnabled,
    setupPasswordFieldErrors,
    isPasswordChangeRequiredSuppressed,
    clearCurrentPasswordWaiver: () => clearCurrentPasswordWaiver($http),
  };
});
